<div class="new-content" *ngIf="((!pane || !pane.loaded) && pane?.users?.length === 0) else contentBlock">
  <loading-line height="40px" width="100%"></loading-line>
</div>

<ng-template #contentBlock>
  <div class="teachers-column" [class.mobile]="deviceService.isMobile()" [class.tablet]="deviceService.isTablet()">
    <ng-template [ngIf]="blockTitle.title">
      <div class="title-wrap">
        <app-library-title [title]="blockTitle" [class.with-sorting]="_pane.show_sorting"></app-library-title>
        <app-library-sorting *ngIf="_pane.show_sorting" [class.with-more]="blockTitle?.see_all_link" [pane]="_pane"></app-library-sorting>
      </div>
    </ng-template>

    <section class="teachers">
      <div *ngFor="let teacher of users;let idx=index; let last = last; trackBy: trackUsersByFn" class="teacher-wrap" [class.last]="last">
        <app-teacher-card [teacher]="teacher"></app-teacher-card>
      </div>
      <ng-template [ngIf]="pane?.infinity">
        <loading-line *ngIf="pane.loading" height="40px" width="100%"></loading-line>
        <span inViewport (inViewportAction)='onInViewportBottomChange($event)'></span>
      </ng-template>
    </section>
  </div>
</ng-template>
